type BarCardProps = {
    title: string | React.ReactNode;
    children: React.ReactNode | null;
}

const BarCard: React.FC<BarCardProps> = ({
    title,
    children = null
}) => {
    return (
        <div className='flex flex-col gap-2 border-l-4 border-purple-600 pl-2.5'>
            {typeof title === 'string' ? <p className='text-lg font-medium px-2 py-1'>{title}</p> : title}
            {children && children}
        </div>
    )
};

export default BarCard;